export default {"src":"/_next/static/media/share-icon-linkedin.39997b2c.svg","height":27,"width":27};